export const WORKBENCH_UNWANTED_WORDS: string[] = [
	'tshirts', 'tshirts', 't-shirt', 't-shirts', 'shirt', 'shirts',
	'tee', 'tees', 'tee shirt', 'tee shirts', 'tees shirt', 'tees shirts'
];
